// extracted by mini-css-extract-plugin
export var lg = "_1e-4";
export var md = "_1e-3";
export var sm = "_1e-2";
export var xs = "_1e-1";
export var xxs = "_1e-0";